"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const deckTypes = {
  home: {
    label: 'Observation Deck',
    path: '/v4/home'
  },
  cloud: {
    label: 'Cloud',
    path: '/v4/cloud'
  },
  recon: {
    label: 'NMS Dashboard',
    path: '/v4/nms'
  },
  synthPerformanceDash: {
    label: 'Synthetics Dashboard',
    path: '/v4/synthetics/dashboard'
  }
};
var _default = exports.default = deckTypes;